/**
 * VendorRaterTypeService
 * Service for managing vendor rater types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor rater type CRUD operations
 */
export class VendorRaterTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorRaterTypeService.DEFAULT_SERVICE_PATH,
            basePath: VendorRaterTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorRaterTypeService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorRaterTypeService.BASE_PATH = 'api/vendor-rater-types';
//# sourceMappingURL=VendorRaterTypeService.js.map